import clsx from 'clsx';
import React, { CSSProperties, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

export const PanelTitleContext = React.createContext({
    leadingContentContainer: null as HTMLElement | null,
    trailingContentContainer: null as HTMLElement | null
});

export function HomePanel(props: { title: string; children?: React.ReactNode; style?: CSSProperties; className?: string }) {
    const [leadingContainer, setLeadingContainer] = useState<HTMLElement | null>(null);
    const [trailingContainer, setTrailingContainer] = useState<HTMLElement | null>(null);

    return (
        <PanelTitleContext.Provider
            value={useMemo(
                () => ({ leadingContentContainer: leadingContainer, trailingContentContainer: trailingContainer }),
                [leadingContainer, trailingContainer]
            )}>
            <div style={{ ...props.style, fontSize: '0.8rem' }} className={clsx('d-flex flex-column', props.className)}>
                <div className="d-flex gap-1 align-items-center border-bottom secondary-bg-color flex-shrink-0 overflow-hidden" style={{ height: 28 }}>
                    <div ref={setLeadingContainer}></div>
                    <div className="flex-grow-1 ps-1">{props.title}</div>
                    <div ref={setTrailingContainer}></div>
                </div>
                <div className="flex-grow-1 min-h-0">{props.children}</div>
            </div>
        </PanelTitleContext.Provider>
    );
}

export function PanelTitleLeadingContent(props: { children?: React.ReactNode }) {
    const ctx = useContext(PanelTitleContext);
    if (!ctx.leadingContentContainer) {
        return null;
    }

    return createPortal(props.children, ctx.leadingContentContainer);
}

export function PanelTitleTrailingContent(props: { children?: React.ReactNode }) {
    const ctx = useContext(PanelTitleContext);
    if (!ctx.trailingContentContainer) {
        return null;
    }

    return createPortal(props.children, ctx.trailingContentContainer);
}
